<template>
  <div id="app">
    <Header />
    <Initiate v-if="!response" />
    <Response :reference="reference" v-if="response" />
    <CenterPiece/>
    <PageFooter />
  </div>
</template>

<script>
import Initiate from "./components/Initiate.vue";
import Response from "./components/Response.vue";
import Header from "./components/PageHeader.vue";
import PageFooter from './components/PageFooter'
import CenterPiece from './components/CenterPiece'
import { utils } from './utility/utility'

const urlParams = utils.getURLParams(window.location.href)

let response = false;
let reference = '';
if (urlParams !== null){

  if (urlParams.response !== undefined ){
    response = urlParams.response;
  }

  if (urlParams.ref !== undefined ){
    reference = urlParams.ref;
  }
}



export default {
  name: "app",
  data: function () {
    return {
      response: response,
      reference: reference
    }
  },
  methods: {
  },
  beforeDestroy: function () {
    localStorage.clear();
  },
  components: {
    Initiate,
    Response,
    Header,
    PageFooter,
    CenterPiece
  }
};
</script>
<style>

@import './assets/css/paygate.css';
@import './assets/css/bootstrap.css';
@import './assets/css/bootstrap-grid.css';
@import './assets/css/bootstrap-reboot.css';

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>


